module.exports = "/assets/b770eeb049530d57fd9084345d18dde6.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/BJ.png
// module id = 1232
// module chunks = 0